import {useState} from 'react'
import Modal from '@/customComponents/uiComponents/modal/Modal.jsx'
import ModalHeader from '@/customComponents/uiComponents/modal/ModalHeader.jsx'
import {
    PoliciesListingContent, PassengerPoliciesContent, DriverPoliciesContent,
    PickupPoliciesContent, TollPoliciesContent, PoliciesExtraDetailsContent,
} from '@/customComponents/globalComponents/policiesContent.jsx'
import {CancellationModificationRefundContent} from '@/customComponents/BookRideSteps/Components/cancellationModificationRefund.jsx'
import {tripPolicyValues, tripCmrPolicy, bookingPolicyValues} from '@/customComponents/globalComponents/policyValues.js'

// Trip-page "Policies — For A Smooth Journey" popup (details / edit / confirm).
// Renders the SAME shared content as the booking-flow policy steps, but the
// dynamic values come from THIS trip's policy_popup (GET-trip response) instead
// of /trips/calculate-policies. Keys mirror the booking step names.
const STEP_CONTENT = {
    passengerPolicies: PassengerPoliciesContent,
    driverPolicies: DriverPoliciesContent,
    pickupPolicies: PickupPoliciesContent,
    tollPolicies: TollPoliciesContent,
    policiesExtraDetails: PoliciesExtraDetailsContent,
}

// The two rows / initialSteps that now open the CMR popup → the tab it opens on.
// CMR reads its tiers from the raw policy_popup, so no separate values needed.
const CMR_STEP_TAB = {
    cancellationPolicies: 'cancellation',
    refundPolicies: 'refund',
}

// `fromCalculatedPolicies` = read the values from /trips/calculate-policies (POLICY_CONSTANTS)
// instead of this trip's response. Used by /confirm, which is treated as a new booking: a
// Draft has no edit_policy / cancellation_policy, so tripCmrPolicy() would render empty tiers
// and tripPolicyValues() empty text. Passing no `policy` to CMR makes it fall back to
// POLICY_CONSTANTS on its own, which is exactly the booking-flow behaviour.
export default function PoliciesPopup({isOpen, onClose, trip, initialStep = 'listing', fromCalculatedPolicies = false}) {
    const [step, setStep] = useState(initialStep)
    // The trip rides along so the no-show rule can be matched to ITS direction and distance
    // when the payload doesn't carry one outright (see policyValues / utils/noShowPolicy).
    const policy = fromCalculatedPolicies ? bookingPolicyValues() : tripPolicyValues(trip?.policy_popup, trip)

    const handleClose = () => {
        onClose?.()
        setTimeout(() => setStep(initialStep), 250)
    }

    const StepComponent = STEP_CONTENT[step]
    const cmrTab = CMR_STEP_TAB[step]

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <ModalHeader
                title=""
                onClose={handleClose}
                onBack={step !== 'listing' ? () => setStep('listing') : undefined}
            />
            <div key={step} className="hopn-view-in hopn-policies-popup">
                {cmrTab
                    ? <CancellationModificationRefundContent policy={fromCalculatedPolicies ? undefined : tripCmrPolicy(trip)} initialTab={cmrTab}/>
                    : StepComponent
                    ? <StepComponent policy={policy} spacing={false}/>
                    : <PoliciesListingContent onOpenStep={setStep} spacing={false}/>}
            </div>
        </Modal>
    )
}
